import {
  SupportedPropertyType,
  TJsonSchemaDocument,
  TSchemaObject,
} from '@commenda/types';
import { v4 as uuidV4 } from 'uuid';

export function makeSchemaObject(
  name: string,
  required = false
): TSchemaObject {
  return {
    id: uuidV4(),
    name,
    type: SupportedPropertyType.OBJECT,
    required,
    properties: [],
  };
}

export function defaultJsonSchemaDocument(): TJsonSchemaDocument {
  return {
    name: '',
    root: makeSchemaObject('root', true),
  };
}
